// eslint-disable-next-line no-restricted-imports
import { useDirectoryGetSchemasQuery } from 'api/generated/graphql';
import { parseDirectorySchemaData, useError } from 'api/helpers';
import { DirectorySchemaData } from 'api/types/data/directory/directory';
import { lodash } from 'helpers';

import { RequestOptions } from '../types';

export const useDirectoryGetSchemas = (options?: RequestOptions) => {
  const {
    loading,
    error: apolloError,
    data,
  } = useDirectoryGetSchemasQuery(options);

  const error = useError(apolloError);

  const schemas: DirectorySchemaData[] | null | undefined =
    data?.directorySchemas
      ? lodash.compact(data?.directorySchemas).map(parseDirectorySchemaData)
      : undefined;

  return { loading, error, schemas };
};
